var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 440,
    viewBox: "0 0 432 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 216,
    cy: 220,
    rx: 216,
    ry: 220,
    fill: "#203240"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 216.571,
    cy: 220.571,
    rx: 148,
    ry: 150.857,
    fill: "#27424F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 215.428,
    cy: 220,
    rx: 85.1429,
    ry: 86.2857,
    fill: "#647A6D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.9dc2047f604f81dca9210c60cbbe629a.svg";
export { ForwardRef as ReactComponent };